<template>
    <div>
        2222
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
};
</script>
<style lang="sass" scoped>

</style>